import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Accordion.scss';
import RichText from 'components/reusableComponents/richText/RichText';

const Accordion = ({ title, subtitle, description, viewMore = 'VOIR PLUS', viewLess = 'VOIR MOINS', startOpen = false,backgroundColor }) => {
 
 
  const [isOpen, setIsOpen] = useState(startOpen);
   const style = {
    backgroundColor  : backgroundColor? backgroundColor
      : '#F9F4F2',
  };


  return (
    <div
      className={`expandable-content${isOpen ? ' opened' : ''}`}
      style={style}
    >
      {/* Title */}
      <div className={`expandable-content__title${isOpen ? ' opened' : ''}`} onClick={() => setIsOpen(!isOpen)}>
        <h4>{title}</h4>
      </div>

      {/* Optional subtitle */}
      {subtitle && subtitle.text && (
        <div className={`expandable-content__sub-title${isOpen ? ' opened' : ''}`}>
          <RichText data={subtitle.text} isExpandableContent={true} />
        </div>
      )}

      {/* Description */}
      {isOpen && description && description.text && (
        <div className={`expandable-content__description${isOpen ? ' opened' : ''}`}>
          <RichText data={description.text} isExpandableContent={true} />
        </div>
      )}

      {/* Expand/Collapse toggle */}
      <div className={`expandable-content__expand${isOpen ? ' opened' : ''}`} onClick={() => setIsOpen(!isOpen)}>
        <div className="expand">
          <span>{isOpen ? viewLess : viewMore}</span>
          <svg
            width="18"
            height="11"
            viewBox="0 0 18 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.5287 0.860622L16.8141 8.30502C17.2133 8.73842 17.2133 9.40128 16.8141 9.80919C16.4149 10.2171 15.7662 10.2171 15.3421 9.80919L8.78019 3.10414L2.21832 9.80919C1.81911 10.2171 1.14546 10.2171 0.74626 9.80919C0.347057 9.40128 0.347057 8.73842 0.74626 8.30502L8.05664 0.860622C8.45584 0.45271 9.10454 0.45271 9.5287 0.860622Z"
              fill="#EA5504"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired, // HTML allowed
  viewMore: PropTypes.string,
  viewLess: PropTypes.string,
  startOpen: PropTypes.bool,
};

export { Accordion };
